<template>
    <div>
        <hd-header></hd-header>
        <div style="padding-top: 130px;">
            <div style="text-align: center;">
                <img src="../../assets/images/progress/five.png" alt="">
            </div>
            <div
                style="display: flex;justify-content: center;align-items: center;margin-bottom: 60px;margin-top: 50px;">
                <el-card style="width: 1000px;">
                    <p style="text-align: center;margin-top: 40px;">
                        <i class="el-icon-success" style="font-size: 80px;color: #5cb138;"></i>
                    </p>
                    <p style="text-align: center;margin-top: 50px;">
                        认证完成，请等待审核
                    </p>
                    <p style="text-align: center;margin-top: 50px;padding-bottom: 50px;">
                        <el-button type="primary" style="width: 180px;" @click="toHome()">返回网站首页</el-button>
                        <el-button type="primary" style="width: 180px;" plain="plain" @click="toUserCenter()">返回用户中心
                        </el-button>
                    </p>
                </el-card>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
    import HdHeader from '../public/Header.vue'
    import HdFooter from '../public/FooterLogined.vue'

    export default {
        name: 'TeacherSuccess',
        components: {
            HdHeader,
            HdFooter
        },
        data: function() {
            return {
                addSchool: 1
            };
        },
        created() {
            if (this.$route.query.hasOwnProperty('addSchool')) {
                this.addSchool = this.$route.query.addSchool;
                console.log('this.addSchool:', this.addSchool);
            }
        },
        methods: {
            toHome: function() {
                this.$router.push({
                    path: '/'
                });
            },
            toUserCenter: function() {
                this.$router.push({
                    path: '/user-center'
                });
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/teacher/TeacherSuccess.vue